import { useEffect, useState } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const teamService = {
  _url: process.env.REACT_APP_TEAM_API_URL,
  _platform_id: process.env.REACT_APP_PLATFORM_ID || 'agentcy',

  GetTeamList(searchQuery, fetch) {
    const [data, setsData] = useState({
      teams: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getAllTeam(searchQuery))
        .then(res => {
          setsData(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [searchQuery, fetch]);

    return {
      _loading: status === STATUS.LOADING,
      _error: status === STATUS.ERROR,
      _data: data,
    };
  },
  GetFilteredTeamList(searchQuery, fetch) {
    const [data, setsData] = useState({
      teams: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getFilteredTeamList(searchQuery))
        .then(res => {
          setsData(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [searchQuery, fetch]);

    return {
      _loading: status === STATUS.LOADING,
      _error: status === STATUS.ERROR,
      _data: data,
    };
  },

  async getAllTeam(searchQuery) {
    // Trailing slash matches backend routing (same as Workflow Labs).
    return await Fetch.get(
      `${this._url}/list/?team_type=user_created&platform_id=${this._platform_id}`,
    );
  },

  async getTeamDetails(id) {
    return await Fetch.get(
      `${this._url}/details?team_id=${id}&platform_id=${this._platform_id}`,
    );
  },

  async getFilteredTeamList(searchQuery) {
    const teamType = searchQuery?.team_type || 'admin_created';
    const platformId = searchQuery?.platform_id || this._platform_id;
    const params = new URLSearchParams({
      team_type: teamType,
      platform_id: platformId,
    });
    return await Fetch.get(`${this._url}/list/?${params.toString()}`);
  },

  async createTeam(payload) {
    return await Fetch.post(`${this._url}/create`, {
      ...payload,
      platform_id: payload.platform_id || this._platform_id,
    });
  },

  async updateTeam(payload) {
    return await Fetch.put(`${this._url}/update`, {
      ...payload,
      platform_id: payload.platform_id || this._platform_id,
    });
  },

  async deleteTeam(id) {
    return await Fetch.delete(
      `${this._url}/delete?team_id=${id}&platform_id=${this._platform_id}`,
    );
  },
};

export default teamService;
